import { c as _c } from "react/compiler-runtime";
import { ContactDetails } from '@/components/Atoms/ContactDetails/ContactDetails';
import { ModalForm } from '@/components/Atoms/ModalForm/ModalForm';
import { Notification } from '@/components/Atoms/Notification/Notification';
import { Prose } from '@/components/Atoms/Prose/Prose';
import { CsrfForm } from '@/components/Molecules/CsrfForm/CsrfForm';
import type { IDialogControl } from '@/components/Molecules/Dialog/Dialog';
import { Dialog, DialogActionsMain } from '@/components/Molecules/Dialog/Dialog';
import { SingleDropdown } from '@/components/Molecules/SingleDropdown/SingleDropdown';
import useTranslation from '@/hooks/useTranslation';
import { trackEvent } from '@/services/Analytics/BBAnalytics';
import { TrackingAction, TrackingCategory } from '@/services/Analytics/bnefAnalyticsSettings';
import type { APIClientError } from '@/services/Http/ApiClientError';
import Trans from 'next-translate/Trans';
import type { FC } from 'react';
import { useEffect, useState } from 'react';
enum State {
  Default,
  Submitting,
  SubmittedOk,
  SubmittedFail,
}
export enum ContactType {
  Feedback = 'feedback',
  Support = 'support',
}
interface IProps {
  dialog: IDialogControl;
  contactType?: ContactType;
}
export const ContactUs: FC<IProps> = t0 => {
  const $ = _c(78);
  const {
    dialog,
    contactType
  } = t0;
  const {
    t
  } = useTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = t("common:Modals.ContactUs.ContactUsOptions.feedback");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = {
      value: ContactType.Feedback,
      label: t1
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("common:Modals.ContactUs.ContactUsOptions.support");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = {
      value: ContactType.Support,
      label: t3
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = [t2, t4];
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const contactTypes = t5;
  const [errorKey, setErrorKey] = useState("");
  const [state, setState] = useState(State.Default);
  const [referrer, setReferrer] = useState("");
  const [referenceNumber, setReferenceNumber] = useState();
  let t6;
  if ($[11] !== contactType || $[12] !== contactTypes || $[13] !== t) {
    t6 = contactType ? contactTypes.find(type => type.value === contactType) : {
      value: "none",
      label: t("common:Modals.ContactUs.ContactUsOptions.default")
    };
    $[11] = contactType;
    $[12] = contactTypes;
    $[13] = t;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const [selectedContactType, setSelectedContactType] = useState(t6);
  let t7;
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      setReferrer(window.location.href);
    };
    t8 = [];
    $[15] = t7;
    $[16] = t8;
  } else {
    t7 = $[15];
    t8 = $[16];
  }
  useEffect(t7, t8);
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = async () => {
      setErrorKey("");
      setState(State.Default);
    };
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  const onClose = t9;
  let t10;
  if ($[18] !== state) {
    t10 = () => {
      if (state !== State.Default) {
        return false;
      }
      setReferenceNumber(undefined);
      setState(State.Submitting);
      trackEvent(TrackingAction.Submit, TrackingCategory.ContactForm);
    };
    $[18] = state;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  const onSubmitStart = t10;
  let t11;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = response => {
      setReferenceNumber(response.inquiryId);
      setState(State.SubmittedOk);
    };
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  const onSubmitEnd = t11;
  let t12;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = e => {
      if (e?.response?.status === 429) {
        setErrorKey("errorRateLimited");
      } else {
        setState(State.SubmittedFail);
      }
    };
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  const onSubmitError = t12;
  let titleKey;
  let modalBody;
  if (state === State.SubmittedOk) {
    titleKey = "common:Modals.ContactUs.ContactUsSuccess.title";
    let t13;
    if ($[22] !== referenceNumber || $[23] !== selectedContactType.value || $[24] !== t) {
      t13 = selectedContactType.value === ContactType.Feedback ? t("common:Modals.ContactUs.ContactUsSuccess.feedback_body") : t("common:Modals.ContactUs.ContactUsSuccess.body", {
        referenceNumber
      });
      $[22] = referenceNumber;
      $[23] = selectedContactType.value;
      $[24] = t;
      $[25] = t13;
    } else {
      t13 = $[25];
    }
    const tranLabel = t13;
    let t14;
    if ($[26] !== tranLabel) {
      t14 = <p>{tranLabel}</p>;
      $[26] = tranLabel;
      $[27] = t14;
    } else {
      t14 = $[27];
    }
    modalBody = t14;
  } else {
    if (state === State.SubmittedFail) {
      titleKey = "common:Feedback.unexpected_error";
      let t13;
      if ($[28] !== t) {
        t13 = t("common:Modals.ContactUs.ContactUsFail.body");
        $[28] = t;
        $[29] = t13;
      } else {
        t13 = $[29];
      }
      let t14;
      if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = <br />;
        $[30] = t14;
      } else {
        t14 = $[30];
      }
      let t15;
      if ($[31] !== t) {
        t15 = t("common:Modals.ContactUs.alternativeContacts");
        $[31] = t;
        $[32] = t15;
      } else {
        t15 = $[32];
      }
      let t16;
      if ($[33] !== t13 || $[34] !== t15) {
        t16 = <p>{t13}{t14}{t15}</p>;
        $[33] = t13;
        $[34] = t15;
        $[35] = t16;
      } else {
        t16 = $[35];
      }
      let t17;
      if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = <ContactDetails />;
        $[36] = t17;
      } else {
        t17 = $[36];
      }
      let t18;
      if ($[37] !== t16) {
        t18 = <>{t16}{t17}</>;
        $[37] = t16;
        $[38] = t18;
      } else {
        t18 = $[38];
      }
      modalBody = t18;
    } else {
      titleKey = "common:Modals.ContactUs.default_title";
      let t13;
      if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = <Trans i18nKey="common:Modals.ContactUs.support_body" components={{
          a: <a href="/help" target="_blank" />
        }} />;
        $[39] = t13;
      } else {
        t13 = $[39];
      }
      let t14;
      if ($[40] !== t) {
        t14 = t("common:Modals.ContactUs.feedback_body");
        $[40] = t;
        $[41] = t14;
      } else {
        t14 = $[41];
      }
      let t15;
      if ($[42] !== t14) {
        t15 = {
          support: t13,
          feedback: t14
        };
        $[42] = t14;
        $[43] = t15;
      } else {
        t15 = $[43];
      }
      const descriptionText = t15;
      let t16;
      if ($[44] !== referrer) {
        t16 = <input type="hidden" name="referrer" value={referrer} />;
        $[44] = referrer;
        $[45] = t16;
      } else {
        t16 = $[45];
      }
      let t17;
      if ($[46] !== contactTypes || $[47] !== selectedContactType.label || $[48] !== selectedContactType.value) {
        t17 = <SingleDropdown title={selectedContactType.label} name="contact-type" onChange={setSelectedContactType} selectedValue={selectedContactType.value} options={contactTypes} />;
        $[46] = contactTypes;
        $[47] = selectedContactType.label;
        $[48] = selectedContactType.value;
        $[49] = t17;
      } else {
        t17 = $[49];
      }
      let t18;
      if ($[50] !== descriptionText || $[51] !== errorKey || $[52] !== selectedContactType.value || $[53] !== state || $[54] !== t) {
        t18 = selectedContactType.value === "none" ? <Prose><p>{t("common:Modals.ContactUs.default_body")}</p></Prose> : <><Prose><p>{descriptionText[selectedContactType.value as keyof typeof descriptionText]}</p>{errorKey && <Notification state="error">{t("common:Modals.ContactUs." + errorKey)}</Notification>}</Prose><textarea name="message" minLength={10} /><DialogActionsMain><button type="submit" disabled={state !== State.Default}>{t("common:Actions.submit")}</button></DialogActionsMain></>;
        $[50] = descriptionText;
        $[51] = errorKey;
        $[52] = selectedContactType.value;
        $[53] = state;
        $[54] = t;
        $[55] = t18;
      } else {
        t18 = $[55];
      }
      let t19;
      if ($[56] !== t17 || $[57] !== t18) {
        t19 = <ModalForm>{t17}{t18}</ModalForm>;
        $[56] = t17;
        $[57] = t18;
        $[58] = t19;
      } else {
        t19 = $[58];
      }
      let t20;
      if ($[59] !== t) {
        t20 = t("common:Modals.ContactUs.alternativeContacts");
        $[59] = t;
        $[60] = t20;
      } else {
        t20 = $[60];
      }
      let t21;
      if ($[61] !== t20) {
        t21 = <p>{t20}</p>;
        $[61] = t20;
        $[62] = t21;
      } else {
        t21 = $[62];
      }
      let t22;
      if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
        t22 = <ContactDetails />;
        $[63] = t22;
      } else {
        t22 = $[63];
      }
      let t23;
      if ($[64] !== t21) {
        t23 = <Prose>{t21}{t22}</Prose>;
        $[64] = t21;
        $[65] = t23;
      } else {
        t23 = $[65];
      }
      let t24;
      if ($[66] !== onSubmitStart || $[67] !== t16 || $[68] !== t19 || $[69] !== t23) {
        t24 = <CsrfForm apiUrl="/feedback" onSubmitStart={onSubmitStart} onSubmitEnd={onSubmitEnd} onSubmitError={onSubmitError}>{t16}{t19}{t23}</CsrfForm>;
        $[66] = onSubmitStart;
        $[67] = t16;
        $[68] = t19;
        $[69] = t23;
        $[70] = t24;
      } else {
        t24 = $[70];
      }
      modalBody = t24;
    }
  }
  let t13;
  if ($[71] !== t || $[72] !== titleKey) {
    t13 = t(titleKey);
    $[71] = t;
    $[72] = titleKey;
    $[73] = t13;
  } else {
    t13 = $[73];
  }
  let t14;
  if ($[74] !== dialog || $[75] !== modalBody || $[76] !== t13) {
    t14 = <Dialog title={t13} {...dialog} onClose={onClose}>{modalBody}</Dialog>;
    $[74] = dialog;
    $[75] = modalBody;
    $[76] = t13;
    $[77] = t14;
  } else {
    t14 = $[77];
  }
  return t14;
};